// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require("es6-promise").polyfill()
Es6Promise.polyfill()
import Vue from 'vue'
import App from './App'
import router from './router'
import './theme/element-#4A7BAE/index.css'
// import Element from 'element-ui'
// Vue.use(Element)
import '../static/admin.css'
import axios from 'axios'
import store from './vuex/store'
import global_ from './Global.vue'

Vue.prototype.GLOBAL = global_
axios.defaults.baseURL = global_.BASE_URL
axios.defaults.withCredentials = true
Vue.prototype.$http = axios
Vue.config.productionTip = false


import FormUiForm from 'formui-vue2-vistastory'
Vue.use(FormUiForm)
import FormUiQuery from 'formui-vue2-vistastory'
Vue.use(FormUiQuery)
import FormUiTableCell from 'formui-vue2-vistastory'
Vue.use(FormUiTableCell)
import FormUiSimpleForm from 'formui-vue2-vistastory'
Vue.use(FormUiSimpleForm)
import FormUiSimpleTable from 'formui-vue2-vistastory'
Vue.use(FormUiSimpleTable)

import qs from 'qs'
Vue.prototype.$qs = qs


// let ktxloading = document.getElementById('ktx-loading')
axios.interceptors.request.use(
  config => {
    //记录token
    // document.getElementById('ktx-loading').style.display = 'block'
    let managertoken = localStorage.getItem('manager-token')
    if (managertoken) {
      config.headers['manager-token'] = managertoken
    }
    return config
  },
  function (error) {
    // document.getElementById('ktx-loading').style.display = 'none'
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(function (response) {
  //  对响应数据做些事
  // document.getElementById('ktx-loading').style.display = 'none'

  if ( location.hash.indexOf('login') != -1 ) {
    return response;
  }
  if(!response.data.status){
      // response.data.status=1
      return response;
  }
  if (response.status !== 200) {
    console.log('ajax 权限验证失败')
    router.replace({
      path: '/admin/login',
      query: {redirect: router.currentRoute.fullPath}
    })
  }
  if (response.data.status.code === 301) {
    console.log('ajax 权限验证失败')
    router.replace({
      path: '/admin/login',
      query: {redirect: router.currentRoute.fullPath}
    })
    return
  }
  if (response.data.status.code === 302) {
    console.log('ajax 权限低')
    router.replace({
      path: '/admin',
      query: { status: 301 }
    })
    return
  }
  return response

}, function (error) {
  // document.getElementById('ktx-loading').style.display = 'none'
  //  请求错误时做些事
  return Promise.reject(error)
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js